import React from "react";
import { FIELD_TYPE, FORMAT_TIME, tabKeys } from "types/enums";
import { ColumnsType } from "antd/es/table";
import { ColumnProps } from "types/models";
import moment from "moment";
import dayjs from "dayjs";

// import DilateStatusCard from "./DilateStatusCard/DilateStatusCard";
import { listGender } from "data/list";
import { DataFormField } from "types/models/input-field-type";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { parseDatetime, toDateTime } from "helper/format-date";
import {
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import { ColumnsEdit } from "types/models/column-table-edit";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
const { INPUT, SELECT, DATE, NUMBER, COMBO_BOX } = FIELD_TYPE;

const dataListPatientResidentialFields = () => {
  const dataListPatientResidentialFields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "maBenhNhan",
      expand: false,
    },
    {
      type: INPUT,
      label: "Tên bệnh nhân",
      name: "tenBenhNhan",
      expand: false,
    },
    {
      type: DATE,
      label: "Ngày sinh",
      name: "ngaySinh",
      expand: false,
    },
    {
      type: NUMBER,
      label: "Số điện thoại",
      name: "soDienThoai",
      expand: false,
    },
    {
      type: INPUT,
      label: "Bác sĩ chỉ định",
      name: "bacSyChiDinh",
      expand: false,
    },

    {
      type: INPUT,
      label: "Số BHYT",
      name: "soTheBaoHiemYTe",
      expand: true,
    },
    {
      type: SELECT,
      label: "Giới tính",
      name: "gioiTinh",
      expand: true,
      options: [
        {
          value: 0,
          label: "Nam",
        },
        { value: 1, label: "Nữ" },
      ],
    },
    {
      type: DATE,
      label: "Từ ngày",
      name: "ngayTaoTu",
      disableDate: false,
      expand: true,
    },
    {
      type: DATE,
      label: "Đến ngày",
      name: "ngayTaoDen",
      expand: true,
      disableDate: false,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái",
      name: "listIdTrangThaiPhauThuat",
      options: JSON.parse(localStorage.getItem("TTPhauThuat")),
      expand: true,
    },
  ];
  return dataListPatientResidentialFields;
};

const allColumnsResidential: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    fixed: "left",
    width: 50,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    isResizable: true,
    align: "center",
    width: 80,
  },
  {
    title: "Mã KB",
    dataIndex: "maKhamBenh",
    show: true,
    isResizable: true,
    align: "center",
    width: 80,
  },
  {
    title: "Tên BN",
    dataIndex: "tenBenhNhan",
    show: true,
    isResizable: true,
    align: "left",
    width: 130,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    align: "left",
    render: (value, record, index) =>
      gioiTinhOptions.find((it) => it.value === value)?.label || "",
    width: 100,
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
    width: 150,
  },
  {
    title: "BS chỉ định",
    dataIndex: "bacSyChiDinh",
    show: true,
    isResizable: true,
    align: "left",
    width: 150,
  },
  {
    title: "Thời gian khám",
    dataIndex: "ngayKham",
    show: false,
    isResizable: true,
    align: "center",
    width: 150,

    render: (value, record, index) => {
      return value
        ? formatDateToString(
            convertIosStringToDateDayjs(value),
            FORMAT_TIME.dateTime
          )
        : "";
    },
  },
  {
    title: "Thời gian chỉ định",
    dataIndex: "ngayChiDinh",
    show: true,
    isResizable: true,
    align: "center",
    width: 150,

    render: (value, record, index) => {
      return value
        ? formatDateToString(
            convertIosStringToDateDayjs(value),
            FORMAT_TIME.dateTime
          )
        : "";
    },
  },
  {
    title: "Số điện thoại",
    width: 150,
    dataIndex: "soDienThoai",
    show: true,
    isResizable: true,
    align: "right",
  },

  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    show: true,
    isResizable: true,
    align: "left",
    width: 200,
  },
  {
    title: "Phương pháp PT",
    dataIndex: "dichVu",
    width: 200,
    show: true,
    isResizable: true,
  },
  {
    title: "Trạng thái",
    dataIndex: "idTrangThaiPhauThuat",
    width: 150,
    show: true,
    isResizable: true,

    render: (text) => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhauThuat")).find(
          (option) => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    isResizable: true,
    align: "center",
    fixed: "right",
    width: 150,
  },
];

export { dataListPatientResidentialFields, allColumnsResidential };
